export default __webpack_public_path__ + "static/media/business restructure.a02a90af.svg";